import React, { FC } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "./ckEditorViewComponent.scss";
interface CKEditorComponentProps {
  value: any;
}
const CKEditorViewComponent: FC<CKEditorComponentProps> = ({ value }) => {
  return (
    <div className="ck-editor-view-component__container">
      <CKEditor
        disabled={true}
        config={{
          toolbar: {
            items: []
          },
        }}
        editor={ClassicEditor}
        data={value}
      />
    </div>
  );
};
export default CKEditorViewComponent;
